import { HttpClient } from '@store/base';
import {
  GetCustomGoodsDetailRequest,
  GetCustomGoodsDetailResponse,
} from '../../model';

export class GetCustomGoodsDetailGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetCustomGoodsDetailRequest) {
    return await this.httpClient.request<GetCustomGoodsDetailResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/custom-goods/${req.gdsCustomNo}`,
    });
  }
}
